export default {
  meta: {
    title: '城市分析',
    url: '/recommend/cityAnalysis', // 埋点用，记录所属模块
  }
};
